<template>
    <div class="panel">
        <div class="row columns">
            <div class="panel-title big-title">
              <div class="large-4 large-centered" v-if="weekList">
                classement {{club.name}}
                <select v-model="selectedLeague">
                  <option v-for="ligue of LeagueList"
                    v-bind:value="ligue">{{ligue.name}}</option>
                </select>
                saison
                <select v-if="selectedLeague" v-model="selectedSeason">
                  <option v-for="season of selectedLeague.seasons"
                    v-bind:value="season">{{season.name}}</option>
                </select>
                </div>
            </div>
        </div>
        <div class="row columns">
            <div class="large-4 large-centered" v-if="weekList">
                Journée :
                <select
                    v-model="selectedWeek">
                    <option v-for="week of weekList"
                        v-bind:value="week">{{ week.title}}</option>
                </select>
            </div>
            <hr>
            <div class="panel-content" v-if="selectedSeason">
                 <div v-for="poule in selectedSeason.ranking_groups">
                    <rankingGroup v-if="selectedWeek"
                                  :selectedWeek="selectedWeek"
                                  :rankingGroup="poule"
                                  :needDB ="club.name == 'Valdemor BBC'" ></rankingGroup>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import rankingGroup from './ranking-group.vue'
import store from '../../store/index.js'

export default {
  name: 'leagueRankingPanel',
  components: {
    rankingGroup
  },
  computed:
  {
    weekList: function () {
      if (this.selectedSeasonValue) {
        return store.getters.weekListForLeague(this.selectedSeasonValue.id)
      }
      return this.$store.getters.weekList
    },
    LeagueList: function () {
      let leagueList = []
      this.club.leagues.forEach(league => {
        let foundLeague = leagueList.find(l => { return l.name === league.name })
        if (foundLeague !== undefined) {
          let seasonObject = {}
          seasonObject.id = league.id
          seasonObject.name = league.season
          seasonObject.ranking_groups = league.ranking_groups
          foundLeague.seasons.push(seasonObject)
        } else {
          let leagueObject = {}
          let seasonObject = {}
          let seasonList = []
          leagueObject.name = league.name
          seasonObject.id = league.id
          seasonObject.name = league.season
          seasonObject.ranking_groups = league.ranking_groups
          seasonList.push(seasonObject)
          leagueObject.seasons = seasonList
          leagueList.push(leagueObject)
        }
      })
      return leagueList
    },
    selectedLeague: {
      get: function () {
        if (this.LeagueList && this.selectedLeagueValue === null) {
          this.selectedLeague = this.LeagueList[this.LeagueList.length - 1]
        }
        return this.selectedLeagueValue
      },
      set: function (newSelectedLeague) {
        this.selectedLeagueValue = newSelectedLeague
        this.selectedSeason = this.selectedLeague.seasons[this.selectedLeague.seasons.length - 1]
      }
    },
    selectedSeason: {
      get: function () {
        if (this.LeagueList && this.weekList && this.selectedLeagueValue !== null && this.selectedSeasonValue === null) {
          this.selectedSeasonValue = this.selectedLeague.seasons[this.selectedLeague.seasons.length - 1]
        }
        return this.selectedSeasonValue
      },
      set: function (newSelectedSeason) {
        this.selectedSeasonValue = newSelectedSeason
        let weekList = store.getters.weekListForLeague(newSelectedSeason.id)
        if (weekList.length > 0) {
          this.selectedWeek = weekList[weekList.length - 1]
        } else {
          this.selectedWeek = null
        }
      }
    },
    selectedWeek: {
      get: function () {
        return this.selectedWeekValue
      },
      set: function (newSelectedWeek) {
        this.selectedWeekValue = newSelectedWeek
        if (newSelectedWeek) {
          this.$store.dispatch('getRankingForWeek', newSelectedWeek.id)
        }
      }
    }
  },
  data () {
    return {
      activatedTab: 1,
      selectedLeagueValue: null,
      selectedSeasonValue: null,
      selectedWeekValue: null
    }
  },
  props: {
    'club': null
  },
  watch: {
    weekList: function (val) {
      // si la liste des semaines arrivent après que les league et season aient été selectionné,
      // on choisit la dernière journée
      if (this.selectedSeasonValue && this.selectedLeagueValue && !this.selectedWeekValue) {
        this.selectedWeek = this.weekList[this.weekList.length - 1]
      }
    }
  },
  created () {
    store.dispatch('getWeekList')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.activated {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

</style>



// WEBPACK FOOTER //
// league-ranking-panel.vue?6de08ed2